'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { safeSetItem } from '@/lib/utils/localStorage'
import { REFERRAL_CODE_PREFIX } from '@/lib/utils/referral/config'

const REFERRAL_CODE_PATTERN = /^[A-Z0-9-]{6,20}$/i

const AdsSourceTracker = () => {
  const searchParams = useSearchParams()

  useEffect(() => {
    const source = searchParams.get('source')
    if (source) {
      safeSetItem('source', source)
    }

    const gclid = searchParams.get('gclid')
    if (gclid) {
      safeSetItem('gclid', gclid)
    }

    const ref = searchParams.get('ref')
    if (ref && REFERRAL_CODE_PATTERN.test(ref) && ref.toUpperCase().startsWith(REFERRAL_CODE_PREFIX)) {
      safeSetItem('referralCode', ref.toUpperCase())
    }
  }, [searchParams])
  return (
    null
  )
}
export default AdsSourceTracker
